//
// DISCLAIMER
//
// Copyright 2026 ArangoDB GmbH, Cologne, Germany
//

import React from "react";
import { Label } from "semantic-ui-react";
import { NotificationSeverity } from "../../api/lib";
import { toSeverity } from "./types";

const severityColor = (severity: NotificationSeverity) => {
  switch (severity) {
    case NotificationSeverity.NOTIFICATION_SEVERITY_CRITICAL:
      return "red";
    case NotificationSeverity.NOTIFICATION_SEVERITY_WARNING:
      return "orange";
    default:
      return "blue";
  }
};

export const SeverityLabel = ({ severity }: { severity: NotificationSeverity }) => {
  const s = toSeverity(severity);
  return (
    <Label size="tiny" color={severityColor(s)}>
      {String(NotificationSeverity[s] || "").replace("NOTIFICATION_SEVERITY_", "")}
    </Label>
  );
};
